import { gql, useQuery } from '@apollo/client';
import { Link, Text } from '@chakra-ui/react';
import NextLink from 'next/link';
import * as React from 'react';

import { Loading } from '@/imports/ui/chakra/components/Loading';

import {
  GroupLinkName_Group,
  GroupLinkName_GroupVariables,
} from './graphql-types/GroupLinkName_Group';

const GROUP = gql`
  query GroupLinkName_Group($input: GroupInput!) {
    group(input: $input) {
      result {
        _id
        name
      }
    }
  }
`;

export const GroupLinkName: React.FC<{
  canAccessCommunityAndGroupFeed: boolean;
  groupId: string;
}> = (props) => {
  const { error, data, loading } = useQuery<
    GroupLinkName_Group,
    GroupLinkName_GroupVariables
  >(GROUP, {
    variables: {
      input: {
        _id: props.groupId,
      },
    },
  });

  if (loading) {
    null;
  }

  if (error || !data?.group.result?.name) {
    return null;
  }

  if (props.canAccessCommunityAndGroupFeed) {
    return (
      <Link
        as={NextLink}
        href={`/community/groups/${data.group.result._id}/activity`}
      >
        {data.group.result.name}
      </Link>
    );
  } else {
    return (
      <Text as="span" textStyle="bodyStrong">
        {data.group.result.name}
      </Text>
    );
  }
};
